import React from 'react'
import { CSVLink } from 'react-csv'

export default function DownloadLink ({ download = {} }) {

  const { rows = [], cols = [], filename = 'data.csv' } = download
  
  return (
    <div className='text-normal text-center p-2'>
      <CSVLink data={rows} filename={filename} headers={cols}>
        <i className={`${`bi bi-download`}`}>&nbsp;Download</i>
      </CSVLink>
    </div>
  )
}
